export default class NameSplit {
  public static formatName(name: string): string {
    if (name.length <= 1) {
      return name.toUpperCase();
    }

    const splitName: string[] = name.split(' ');
    const firstWord: string = splitName[0];
    const firstLetterOfFirstWord: string = firstWord[0];

    if (splitName.length === 1) {
      const secondLetterOfFirstWord: string = firstWord[1];
      return `${firstLetterOfFirstWord}${secondLetterOfFirstWord}`;
    }

    const lastWord: string = splitName[splitName.length - 1];
    const firstLetterOfLastWord: string = lastWord[0];
    return (`${firstLetterOfFirstWord}${firstLetterOfLastWord}`).toUpperCase();
  }
}
